import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { Tooltip } from 'react-tooltip';

import { TOOLTIP_STYLES } from '../styles';

export const CheckboxGroupUI = styled.div<{ $columnCount: number; $rowCount: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columnCount }) => $columnCount}, minmax(0, 1fr));
  grid-auto-flow: column;
  grid-template-rows: repeat(${({ $rowCount }) => $rowCount}, 1fr);
  grid-gap: 3px 15px;
`;

export const CheckBox = styled.div`
  break-inside: avoid;
  min-width: 0;
  display: flex;
  align-items: center;
`;

export const LabelWrapper = styled.span`
  font-size: 14px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-left: 6px;
`;

export const Label = styled.label<{ disabled: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Input = styled.input`
  width: 12px;
  height: 12px;
  border: 1px solid ${COLORS.BLACK};
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
    border-color: inherit;
  }

  &:checked {
    background-color: ${COLORS.BLUE_11};
    border-color: ${COLORS.BLUE_11};
  }

  &:disabled {
    background-color: ${COLORS.GREY_29};
    opacity: 1;
    cursor: default;
  }
`;

export const LenderNameTooltip = styled(Tooltip)`
  ${TOOLTIP_STYLES}

  color: ${COLORS.BLACK} !important;
  background-color: ${COLORS.WHITE_2} !important;

  &.react-tooltip-arrow {
    color: ${COLORS.WHITE_2} !important;
  }

  &.react-tooltip__place-top-start {
    margin-top: 10px;
  }

  &.react-tooltip__place-bottom-start {
    margin-top: -10px;
  }
`;
